
import React from 'react';
import { FormattedMessage } from 'react-intl';

export default class InfoMessage extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
   
    let bubbleClass = 'bubble tip';

    if (!this.props.isNeedTest) {
      return <>{null}</>
    }



    return (
      <div className="card">
        
          <FormattedMessage id="newtopic_dotest_desc" defaultMessage="Loading..."
                      description="Label for Test" /> 
            {' '}
            <a href='#' onClick={(e) => {
                    e.preventDefault();
                    this.props.showTestView();
                }}>
                  <FormattedMessage id="button_dotest" defaultMessage="Go to the test"
                    description="Button [Test]" />
            </a>
     
      </div>
      
    );
  }
};
